export default "__VITE_ASSET__1ada7b8c__"